import React, { useEffect, useState } from 'react'
import './SalesShift.css'
import { Button, Calendar, Col, Dropdown, Menu, Radio, Row } from 'antd'
import { BASE_URL, ShiftLogs } from '../../utils/constant';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css'
import { FaAngleDown } from "react-icons/fa6";
function SalesShift({salesDepartmentId , defaultSelectedFiscalYear, currentYearSelected,fiscalYear }) {
const [staffShiftData, setStaffShiftData] = useState([])
const[selectedFiscalYea,setSelectedFiscalYea]=useState(defaultSelectedFiscalYear)

const handleFiscalYearChan = (year) => {
  setSelectedFiscalYea(year);

};
const fiscalYearMenu = (
  <Menu onClick={(e) => handleFiscalYearChan(e.key)}>
    {fiscalYear.map((year) => (
      <Menu.Item key={year}>
        {year}
      </Menu.Item>
    ))}
  </Menu>
);
    useEffect(() => {
        getStaffDayList();
      }, [selectedFiscalYea]);
      const capitalizeFirstLetter = (str) => {
        return str?.replace(/\b\w/g, (char) => char.toUpperCase());
      };
      const getStaffDayList = async () =>{
        const token = localStorage.getItem('authToken');
      
        const fetchData = async () => {
          const response = await fetch(`${BASE_URL}/${ShiftLogs}`, {
            method: "POST",
             headers: {
                      'Content-Type': 'application/json',
                      'Authorization': `${token}`,
                      
                    },
            body: JSON.stringify({
                "staffId" : salesDepartmentId,
                // "month" : parseInt(selectedMonthNumber),
                "year" :selectedFiscalYea?parseInt(selectedFiscalYea.split("-")[0]) : parseInt(currentYearSelected - 1)
            }),
          });
          
          if (response.ok) {
            const data = await response.json();
            setStaffShiftData(data?.data)
            console.log('ShiftLogs',data)
            
      
          } else {
            const data = await response.json();
            console.log('stafTodayerr',data)
            // toast.error(data.errorMessage, {
            //   position: toast.POSITION.TOP_RIGHT,
            // });
            
          }
        };
       
        await fetchData();
       
      }

      const columns = [
        { headerName: '', field: 'date' , width: 70,}, // First column for dates
        { headerName: 'March', field: 'march' , width: 120,
        cellStyle: params => {
          if(params.colDef.field.toLowerCase() !== currentMonth){

            return {color: params.data.marchtxt, backgroundColor: params.data.marchbg};
          }else{
            
            return {color: params.data.marchtxt, backgroundColor: '#c1e5f1'};
          }
      
  },
        cellRenderer: (params) => {
          return(
          <p >{params.value}</p>
        )
         }},
        { headerName: 'February', field: 'february', width: 120,
        cellStyle: params => {
          if(params.colDef.field.toLowerCase() !== currentMonth){
              return {color: params.data.februarytxt, backgroundColor: params.data.februarybg};
          
      }else{
            
        return {color: params.data.februarytxt, backgroundColor: '#c1e5f1'};
      }
    },
        cellRenderer: (params) => {
          return(
           
                <p>{params.value}</p>
                )
         }
         },
        { headerName: 'January', field: 'january', width: 120 ,
        cellStyle: params => {
          if(params.colDef.field.toLowerCase() !== currentMonth){

          return {color: params.data.januarytxt, backgroundColor: params.data.januarybg};
       
        }else{
            
          return {color: params.data.januarytxt, backgroundColor: '#c1e5f1'};
        }
      },
        cellRenderer: (params) => {
          return(
          <p >{params.value}</p>
        )
         }},
        { headerName: 'December', field: 'december', width: 120  ,
        cellStyle: params => {
          if(params.colDef.field.toLowerCase() !== currentMonth){

          return {color: params.data.decembertxt, backgroundColor: params.data.decemberbg};
      
        }else{
            
          return {color: params.data.decembertxt, backgroundColor: '#c1e5f1'};
        }
      },
        cellRenderer: (params) => {
          return(
          <p >{params.value}</p>
        )
         }},
        { headerName: 'November', field: 'november', width: 120  ,
        cellStyle: params => {
          if(params.colDef.field.toLowerCase() !== currentMonth){

          return {color: params.data.novembertxt, backgroundColor: params.data.novemberbg};
      
        }else{
            
          return {color: params.data.novembertxt, backgroundColor: '#c1e5f1'};
        }
      },
  
        cellRenderer: (params) => {
          return(
          <p>{params.value}</p>
        )
         }},
        { headerName: 'October', field: 'october', width: 120  ,
        cellStyle: params => {
          if(params.colDef.field.toLowerCase() !== currentMonth){

          return {color: params.data.octobertxt, backgroundColor: params.data.octoberbg};
      

        }else{
            
          return {color: params.data.octobertxt, backgroundColor: '#c1e5f1'};
        }
      },
  
        cellRenderer: (params) => {
          return(
          <p >{params.value}</p>
        )
         }},
        { headerName: 'September', field: 'september', width: 120  ,
        cellStyle: params => {
          if(params.colDef.field.toLowerCase() !== currentMonth){

          return {color: params.data.septembertxt, backgroundColor: params.data.septemberbg};
    
        }else{
            
          return {color: params.data.septembertxt, backgroundColor: '#c1e5f1'};
        }
      },
        cellRenderer: (params) => {
          return(
          <p >{params.value}</p>
        )
         }},
        { headerName: 'August', field: 'august', width: 120  ,
        cellStyle: params => {
          if(params.colDef.field.toLowerCase() !== currentMonth){

          return {color: params.data.augusttxt, backgroundColor: params.data.augustbg};
      
 
        }else{
            
          return {color: params.data.augusttxt, backgroundColor: '#c1e5f1'};
        }
      },
        cellRenderer: (params) => {
          return(
          <p>{params.value}</p>
        )
         }},
        { headerName: 'July', field: 'july', width: 120  ,
        cellStyle: params => {
          if(params.colDef.field.toLowerCase() !== currentMonth){

          return {color: params.data.julytxt, backgroundColor: params.data.julybg};
        }else{
            
          return {color: params.data.julytxt, backgroundColor: '#c1e5f1'};
        }
      },
        cellRenderer: (params) => {
          return(
          <p >{params.value}</p>
        )
         }},
        { headerName: 'June', field: 'june', width: 120  ,
        cellStyle: params => {
          if(params.colDef.field.toLowerCase() !== currentMonth){

          return {color: params.data.junetxt, backgroundColor: params.data.junebg};
        }else{
            
          return {color: params.data.junetxt, backgroundColor: '#c1e5f1'};
        }
      },
        cellRenderer: (params) => {
          return(
          <p>{params.value}</p>
        )
         }},
        { headerName: 'May', field: 'may', width: 120  ,
        cellStyle: params => {
          if(params.colDef.field.toLowerCase() !== currentMonth){

          return {color: params.data.maytxt, backgroundColor: params.data.maybg};
        }else{
            
          return {color: params.data.maytxt, backgroundColor: '#c1e5f1'};
        }
  },
        cellRenderer: (params) => {
          return(
          <p >{params.value}</p>
        )
         }},
        { headerName: 'April', field: 'april', width: 120  ,
        cellStyle: params => {
          if(params.colDef.field.toLowerCase() !== currentMonth){

          return {color: params.data.apriltxt, backgroundColor: params.data.aprilbg};
        }else{
            
          return {color: params.data.apriltxt, backgroundColor: '#c1e5f1'};
        }
        },
        cellRenderer: (params) => {
          return(
          <p >{params.value}</p>
        )
         }},
      ];
    
      const data = [];
      const columnsWithData = new Set(); // To track columns with data
      
      for (let day = 1; day <= 31; day++) {
          const row = { date: day.toString() };
          staffShiftData?.logs?.forEach((monthData) => {
            monthData?.forEach((attendance) => {
              const date = new Date(attendance.logDate);
              const monthName = date.toLocaleString('default', { month: 'long' }).toLowerCase();
              const monthNamecolor = date.toLocaleString('default', { month: 'long' }).toLowerCase().concat('bg');
              const monthNametxtcolor = date.toLocaleString('default', { month: 'long' }).toLowerCase().concat('txt');
              
                  const attendanceDay = date.getDate();
                  if (day === attendanceDay) {
                      if (attendance.isWeeklyOff) {
                          row[monthName] = 'W/O';
                          columnsWithData.add(monthName);
                        } else {
                        row.item = staffShiftData.shifts[attendance.shiftId];
                          const shiftDetails = staffShiftData.shifts[attendance.shiftId];
                          row[monthName] = shiftDetails ? capitalizeFirstLetter(shiftDetails.shiftShortName) : '';
                          row[monthNamecolor] = shiftDetails?.color?.bgCode;
                          row[monthNametxtcolor] = shiftDetails?.color?.txtCode;
                          columnsWithData.add(monthName);
                      }
                  }
              });
          });
          data.push(row);
      }
      
      // Filter columns based on columnsWithData
      const filteredColumns = columns.filter(column => column.field === 'date' || columnsWithData.has(column.field));
      
    // const gridOptions = {
    //   columnDefs: columns,
    //   rowData: data,
    //   defaultColDef: {
    //     width: 120,
    //     resizable: true,
    //   },
    //   domLayout: 'autoHeight',
    //   suppressHorizontalScroll: true,
    //   getRowClass: (params) => {
    //     console.log('params?.colDef?.field',params)
    //     // Add a custom class to the current month column and date cell
    //     const currentMonth = new Date().toLocaleString('default', { month: 'long' }).toLowerCase();
    //     const isCurrentMonth = params?.colDef?.field === currentMonth;
    //     const isCurrentDate =  params.data.date === new Date().getDate().toString();
  
    //     return isCurrentMonth || isCurrentDate ? 'highlighted-row' : '';
    //   },
    // };
    const scroll = { x: 800 };
    const today = new Date();
  const currentMonth = today.toLocaleString('default', { month: 'long' }).toLowerCase();
  const currentDate = today.getDate();

    
  const getHeaderCellStyle = (params) => {
    const headerStyle = {};

    if (params.colDef.field.toLowerCase() === currentMonth) {
      // Highlight the header of the current month column with a blue background
      headerStyle.backgroundColor = 'blue';
      headerStyle.color = 'white'; // Set text color to white for better visibility
    }

    return headerStyle;
  };
    const getCellStyle = (params) => {
      const day = parseInt(params.data.date, 10);
      const cellStyle = {};
  
      if (params.colDef.field === 'date' ) {
       
        cellStyle.display= "flex";
        cellStyle.alignItems= "center";
        cellStyle.justifyContent= "center";
        
      }
      if (params.colDef.field === 'date' && day === currentDate) {
        // Highlight the current date with a blue circle background
       
        cellStyle.borderRadius = '50%';
    cellStyle.width= '36px';
    cellStyle.fontSize= '12px';
    cellStyle.display= 'flex';
    cellStyle.alignItems= "center";
    cellStyle.justifyContent= "center";
    cellStyle.backgroundColor= "#c1e5f1";
    cellStyle.marginLeft= "19px";
    cellStyle.marginTop= "3px";
    cellStyle.borderRadius= "50%";
    cellStyle.height= "34px";
      }
  
      if (params.colDef.field.toLowerCase() === currentMonth) {
        // Highlight the whole current month column with a light blue background
        cellStyle.backgroundColor = '#c1e5f1';
      }
  
      return cellStyle;
      
    };
    const getHeaderClass = (params) => {
      // Ensure that params.colDef is defined before accessing its field property
      if (params.colDef && params.colDef.field && params.colDef.field.toLowerCase() === currentMonth) {
        // Return the custom class for the header of the current month column
        return 'current-month-header';
      }
      return null; // Return null for other headers
    };
    const defaultColDef = {
      // ... (existing defaultColDef properties remain unchanged)
      cellStyle: getCellStyle, // Apply the custom style for each cell
      headerComponentParams: getHeaderClass, // Apply the custom style for each header cell

    };
    return (
        <div>
            <div className="ag-theme-alpine" style={{ height: 600, width: '100%', marginTop: "10px" }}>
              <Dropdown overlay={fiscalYearMenu} placement="bottom">
        <Button className="bg-[#F1F6FD] border-[#F1F6FD] font-semibold h-[38px] flex items-center !pr-3 !outline-none">{selectedFiscalYea} <FaAngleDown className='ml-2 text-xs text-[#4B8AEB]' /></Button>
      </Dropdown>
            <AgGridReact rowData={data} columnDefs={filteredColumns} defaultColDef={defaultColDef}/>
            {/* <AgGridReact {...gridOptions} /> */}
                        </div>
            {/* <div className='mt-5'>
                <Table className="table-scroll salesshift-table mt-5" scroll={scroll} columns={columns} dataSource={data} bordered pagination={false} />
            </div> */}
        </div>
    )
}

export default SalesShift